// WCAG 2.1 AA contrast ratios, shared with the Academy web app so both apply the same
// thresholds.
export const WCAG_AA_RATIO = 4.5;
export const WCAG_NON_TEXT_RATIO = 3;
